import { ScrollService } from '../../../../services/scroll.service';
import { Component, OnDestroy, OnInit } from '@angular/core';


@Component({
    selector: 'lf-organization-dashboard',
    styleUrls: ['./organization-dashboard.scss'],
    templateUrl: './organization-dashboard.component.html',
})
export class OrganizationDashboardComponent implements OnInit, OnDestroy
{

    constructor(
            private _scrollService: ScrollService,
    ) {
    }

    ngOnInit(): void {
        // Scroll to top on view load.
        this._scrollService.scrollToTop();
    }

    ngOnDestroy() {
        // blank
    }

}
